import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { OAuth2Service, OAuth2Status } from './angular-rest';

/**
 * Punto di entrata dell'applicazione. Il suo scopo è solamente
 * iniettare/caricare gli altri componenti e, nel caso si perda
 * il login (scaduto/on logout) reindirizza l'utente ad una 
 * pagina di login.
 * 
 * @export
 * @class AppComponent
 */
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent {
	constructor(
		auther: OAuth2Service,
		router: Router
	) {
		auther.statusChanged.subscribe((status) => {
			if (status === OAuth2Status.Unauthorized) {
				router.navigate( [ '/login' ], { queryParams: { reason: '1' } } );
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts